import { useState } from "react";
import usePWAInstall, { isIOS, isInStandaloneMode } from "../../hooks/usePWAInstall";
import { THEME_COLOR, CLUB_NAME } from "../../config/club";
export default function PWAInstallBanner() {
    const { isInstallable, promptInstall } = usePWAInstall();

    // 🎨 Swap this for your theme color
    const themeColor = THEME_COLOR;
    const [dismissed, setDismissed] = useState(false);

    // useEffect(() => {
    //     const saved = localStorage.getItem("pwaInstallDismissed");
    //     if (saved === "true") setDismissed(true);
    // }, []);

    const closeBanner = () => {
        //localStorage.setItem("pwaInstallDismissed", "true");
        setDismissed(true);
    };


    const CloseBtn = (
        <button
            onClick={closeBanner}
            aria-label="Close"
            style={{
                position: "absolute",
                top: 8,
                right: 10,
                border: "none",
                background: "transparent",
                fontSize: "1.2rem",
                color: "var(--muted-text)",
                cursor: "pointer",
                lineHeight: 1,
            }}
        >
            ✕
        </button>
    );

    if (dismissed || isInStandaloneMode()) return null;

    // Base style for the floating container
    const floatingStyle = {
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1050,
        width: "calc(100% - 40px)",
        maxWidth: "400px",
        borderRadius: "20px",
        backdropFilter: "blur(16px)",
        background: "var(--card-bg)",
        border: "1px solid var(--border-color)",
        boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
        animation: "slideUp 0.5s ease-out"
    };

    // iOS UI
    if (isIOS()) {
        return (
            <div style={floatingStyle} className="p-3 text-center">
                {CloseBtn}
                <style>
                    {`@keyframes slideUp { from { transform: translate(-50%, 100px); opacity: 0; } to { transform: translate(-50%, 0); opacity: 1; } }`}
                </style>
                <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
                    <span className="fs-5">📱</span>
                    <span className="fw-bold" style={{ color: "var(--text-color)" }}>Install App</span>
                </div>
                <p className="small text-muted mb-0">
                    Open this page in <strong>Safari</strong> or an external browser, then tap
                    <i className="bi bi-box-arrow-up mx-1" style={{ color: themeColor }}></i>
                    <strong>Share</strong> and select <strong>“Add to Home Screen”</strong>
                </p>

            </div>
        );
    }

    if (!isInstallable) return null;

    // Android / Chrome UI
    return (
        <div style={floatingStyle} className="p-3">
            {CloseBtn}
            <style>
                {`@keyframes slideUp { from { transform: translate(-50%, 100px); opacity: 0; } to { transform: translate(-50%, 0); opacity: 1; } }`}
            </style>
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-3">
                    <div
                        className="rounded-3 d-flex align-items-center justify-content-center"
                        style={{
                            width: "40px", height: "40px",
                            backgroundColor: `${themeColor}15`,
                            color: themeColor
                        }}
                    >
                        <i className="bi bi-cloud-arrow-down-fill fs-5"></i>
                    </div>
                    <div>
                        <div className="fw-bold mb-0" style={{ fontSize: "0.95rem" }}>{CLUB_NAME}</div>
                        <div className="text-muted" style={{ fontSize: "0.8rem" }}>Add to your home screen</div>
                    </div>
                </div>
                <button
                    className="btn btn-sm px-3 rounded-pill"
                    onClick={promptInstall}
                    style={{
                        backgroundColor: themeColor,
                        color: "white",
                        fontWeight: "600",
                        border: "none"
                    }}
                >
                    Install
                </button>
            </div>
        </div>
    );
}